<template>
    <b-form-group
        :label="label || $t('form.label.userRelations')"
        label-for="userRelations"
    >
        <multiselect
            id="userRelations"
            :state="state"
            :selected="value"
            :options="userRelationsOptions"
            @changeValue="$emit('update:value', $event)"
            @changeSearch="debouncedSearchHandler"
            :disabled="disabled"
            :loading="isLoading"
            :placeholder="$t('form.placeholder.searchByUserName')"
            :no-elements-found="$t('form.multiselect.noUserWasFound')"
        >
            <template slot="c-option" slot-scope="{ options: { option } }">
                <span>{{ option.label }}</span>
            </template>
        </multiselect>
    </b-form-group>
</template>

<script>
import api from '@/services/api'
import { Multiselect, mapperToOptions } from '@/views/components/selects'
import { sortBy, debounce } from 'lodash'
import { mapGetters } from 'vuex'

export default {
    name: 'UserRelations',
    components: {
        Multiselect,
    },
    props: ['value', 'state', 'disabled', 'label'],
    data() {
        return {
            userRelationsOptions: [],
            model: null,
            isLoading: false,
        }
    },
    created() {
        this.debouncedSearchHandler = debounce(this.searchUserByName, 1000)
        this.$emit('ready', true)
    },
    mounted() {
        if (!this.userRelationsOptions.length) {
            this.mapCurrentUserSubordinates()
        }
    },
    methods: {
        searchUserByName(query) {
            if (query && query.trim()) {
                this.isLoading = true
                let params = {
                    orderBy: 'name',
                    filter: 'id;name',
                    search: `name:${query};has_goal:1`,
                    and: 'yes',
                }
                return api
                    .get('/users', { params })
                    .then(resp => {
                        const {
                            data: { data },
                        } = resp
                        this.userRelationsOptions = mapperToOptions(
                            data,
                            undefined,
                            'name'
                        )
                    })
                    .catch(error => {
                        console.log(error)
                    })
                    .finally(() => {
                        this.isLoading = false
                    })
            } else {
                this.userRelationsOptions = []
            }
        },
        mapCurrentUserSubordinates() {
            let users = sortBy(
                [...this.currentUser.subordinates, this.currentUser],
                user => user.name
            )
            this.userRelationsOptions = mapperToOptions(
                users,
                undefined,
                'name'
            )
        },
    },
    computed: {
        ...mapGetters({
            currentUser: 'getCurrentUser',
        }),
    },
    watch: {
        userRelationsOptions() {
            if (!this.userRelationsOptions.length) {
                this.mapCurrentUserSubordinates()
            }
        },
    },
}
</script>
